export enum LOGIN_MODAL_CHALLENGE_URL {
  FORGOT_LOGIN = '/login/login/getProfileForCustomer',
  LOGIN = '/pf-ws/authn/flows/'
}
export enum GENERIC {
  CUSTOM = 'custom',
  LOGIN_SCREEN = 'Login Screen'
}
